import { Observable } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import {
    IModalComponent,
    ModalOverlayRef,
    ModulesSelectors,
} from '@serviceos-ng/core';
import { GdprService } from '../gdpr.service';

@Component({
    selector: 'serviceos-web-gdpr-modal',
    templateUrl: './gdpr-modal.component.html',
    styleUrls: ['./gdpr-modal.component.scss'],
})
export class GdprModalComponent implements OnInit, IModalComponent {

    @Select(ModulesSelectors.getModuleConfigText('customer'))
    moduleCustomerTexts$!: Observable<any>;
    
    @Select(ModulesSelectors.getComponentFromModule('customer', 'gdpr.tracking_preferences_screen'))
    gdprModalConfig$!: Observable<any>

    public activeScreen = 'how_it_work';

    public preferences = {
        performanceCookies: true,
        functionalCookies: true,
        targetingCookies: true,
    };

    @ViewChild('accordionMobile')
    accordionMobile!: NgbAccordion;

    constructor(
        public modalRef: ModalOverlayRef,
        private store: Store,
        private gdprService: GdprService
    ) {}

    ngOnInit(): void {}

    cookiePolicy() {
        const cookiePolicyUrl = this.store.selectSnapshot(
            ModulesSelectors.getSetting('cookie_policy_url')
        );

        window.location.href = cookiePolicyUrl;
        // this.router.navigateByUrl(cookiePolicyUrl);
    }

    changePanel(event) {
        if (event?.panelId == 'more') {
            this.activeScreen = 'how_it_work';
        } else if (event?.panelId) {
            this.activeScreen = event.panelId;
        }

        if (event.nextState == false) {
            event.preventDefault();
        }
    }

    confirm() {
        this.gdprService.setGDPRPreferences(this.preferences);
        this.modalRef.close();
        // Reload the page when some of the preferences is change. Other wise we d'not need to change it.
        if (
            !this.preferences.functionalCookies ||
            !this.preferences.performanceCookies ||
            !this.preferences.targetingCookies
        ) {
            window.location.reload();
        }
    }
}
